// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3_PLX","selects":"Documents_selects__2hLR_"};